import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllBuilderProducts(id) {
    const data = useStaticQuery(graphql`
        query{
            allBuilderModels{
                airProduct(limit: 100, options: { cachebust: true }){
                    id
                    data{
                        releaseDate
                        releaseDateValue
                        legacy
                        featured
                        image
                        badge
                        name
                        sku
                        url
                        description
                        shortDescription
                        category
                        worksWith
                        tryItFree
                        includes
                        requires
                        pimcoreStagingId
                        pimcoreProductionId
                    }
                }
            }
        }
    `)

    const arr = data.allBuilderModels.airProduct.map(({ id, data }) => ({ id, ...data }))

    if(id) return arr.find(_ => _.id === id || _.sku === id)
    return arr.sort((a, b) => {
        const x = a?.data?.releaseDateValue
        const y = b?.data?.releaseDateValue

        if(!x && !y) return 0

        if(x && !y) return -1
        if(!x && y) return 1

        if(x > y) return -1
        if(x < y) return 1

        return 0
    })
}
